// @ts-nocheck
/**
 * fileImport.ts
 * ファイルドロップ/インポート関連メソッド
 * App.vue から切り出し
 */

import * as Layers from '@/js/layers'
import { clickCircleSource } from '@/js/layers'
import { kml } from '@tmcw/togeojson'
import { gpx } from '@tmcw/togeojson'
import * as turf from '@turf/turf'
import {
  kmlLoadForUser,
  kmzLoadForUser,
  getCRS,
  xmlToGeojson,
  transformGeoJSONToEPSG4326,
  geojsonAddLayer,
} from '@/js/downLoad'
import { parseCSV, detectLatLonColumns } from '@/js/downLoad'
import shp from 'shpjs'
import { showInfo } from '@/js/utils/messageHelper'
import { consumeToken } from '@/js/tokenService'

type VM = any

// localStorage マイグレーション
export function migrateLocalStorage(): void {
  try {
    // 現在のアプリケーションバージョンを取得
    const currentVersion = '0.1.0'; // package.jsonから
    const storedVersion = localStorage.getItem('oh3.appVersion');

    // バージョンが異なる場合、またはバージョン情報がない場合
    if (storedVersion !== currentVersion) {
      console.warn('[localStorage Migration] Version mismatch detected. Clearing incompatible localStorage data...');

      // 保持すべき重要なキー
      const keysToPreserve = [
        'lastUserId',
        'oh3.appVersion'
      ];

      // 保存しておくデータ
      const preservedData = {};
      keysToPreserve.forEach(key => {
        const value = localStorage.getItem(key);
        if (value !== null) {
          preservedData[key] = value;
        }
      });

      // ユーザー別のお気に入りキーも保持
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('oh3.favoriteLayerIds.')) {
          preservedData[key] = localStorage.getItem(key);
        }
      });

      // localStorageをクリア
      localStorage.clear();

      // 保持すべきデータを復元
      Object.keys(preservedData).forEach(key => {
        localStorage.setItem(key, preservedData[key]);
      });

      // 新しいバージョンを保存
      localStorage.setItem('oh3.appVersion', currentVersion);
    }
  } catch (error) {
    console.error('[localStorage Migration] Error during migration:', error);
    // エラーが発生してもアプリケーションは続行
  }
}

export async function handleFlowSelected(vm: VM): Promise<void> {
  const flowAction = vm.$store.state.fileDropFlow.action;
  const files = vm.$store.state.fileDropFlow.files;

  if (!flowAction || !files || files.length === 0) return;

  const map = vm.$store.state.map01;
  const file = files[0];
  vm.s_geojsonFile = file; // ← 既存のコードとの互換性のために追加
  const fileName = file.name;
  vm.s_gazoName = fileName.split('.')[0];
  const fileExtension = fileName.split('.').pop().toLowerCase();
  const reader = new FileReader();

  switch (flowAction) {
    case 'kml-draw':
      reader.onload = (event) => {
        const parser = new DOMParser();
        const kmlText = event.target.result;
        const kmlData = parser.parseFromString(kmlText, 'application/xml');
        vm.geojsonForDraw = kml(kmlData);
        vm.dialogForDraw = true;
      };
      reader.readAsText(file);
      break;

    case 'kml-load':
      if (vm.$store.state.userId) {
        const map01 = vm.$store.state.map01;
        const map02 = vm.$store.state.map02;
        vm.$store.state.tiffAndWorldFile = files;
        reader.onload = async (event) => {
          kmlLoadForUser(map01, true);
          kmlLoadForUser(map02, false);
        };
        reader.readAsText(file);
      }
      break;

    case 'kmz-load':
      if (vm.$store.state.userId) {
        const map01 = vm.$store.state.map01;
        const map02 = vm.$store.state.map02;
        vm.$store.state.tiffAndWorldFile = files;
        reader.onload = async (event) => {
          kmzLoadForUser(map01, true);
          kmzLoadForUser(map02, false);
        };
        reader.readAsArrayBuffer(file);
      }
      break;

    case 'sima-import':
      vm.$store.state.tiffAndWorldFile = files;
      reader.onload = (event) => {
        const arrayBuffer = event.target.result;
        const text = new TextDecoder("shift-jis").decode(arrayBuffer);
        vm.ddSimaText = text;
        vm.s_dialogForSimaApp = true;
      };
      reader.readAsArrayBuffer(file);
      break;

    case 'geotiff-load':
      vm.$store.state.tiffAndWorldFile = files;
      vm.s_dialogForGeotiffApp = true;
      break;

    case 'geotiff-single': {
      const zahyokei = await getCRS(file);
      if (zahyokei) {
        vm.$store.state.zahyokei = zahyokei;
        vm.$store.state.tiffAndWorldFile = files;
        vm.dialogForGeotiffApp1file = true;
      } else {
        vm.$store.state.tiffAndWorldFile = files;
        vm.s_dialogForGeotiff2App = true;
      }
      break;
    }

    case 'jpg-with-world':
      vm.$store.state.tiffAndWorldFile = files;
      vm.s_dialogForJpgApp = true;
      break;

    case 'jpg-warp':
      if (vm.$store.state.userId) {
        reader.onload = evt => {
          vm.s_gazoName = fileName.split('.')[0];
          vm.$store.state.pendingFile = file;
          vm.$store.dispatch('showFloatingWindow', 'warp-wizard');
        };
        reader.readAsDataURL(file);
      }
      break;

    case 'png-with-world':
      if (vm.$store.state.userId) {
        vm.$store.state.tiffAndWorldFile = files;
        vm.s_dialogForPng2App = true;
      }
      break;

    case 'png-warp':
      if (vm.$store.state.userId) {
        reader.onload = evt => {
          vm.s_gazoName = fileName.split('.')[0];
          vm.$store.state.pendingFile = file;
          vm.$store.dispatch('showFloatingWindow', 'warp-wizard');
        };
        reader.readAsDataURL(file);
      }
      break;

    case 'png-marker':
      if (vm.$store.state.userId) {
        showInfo('測位アイコンに移動しました。');
      }
      break;

    case 'pdf-viewer':
      if (vm.$store.state.userId) {
        const cd = vm.$store.state.commonDialog;
        cd.fileDropOpen = true;
        cd.fileDropExt = 'pdf';
        cd.fileDropFiles = files;
      }
      break;

    case 'touhon-overlay':
      if (vm.$store.state.userId) {
        vm.$store.state.touhonOverlayFile = file;
        vm.$store.dispatch('showFloatingWindow', 'touhon-overlay');
      }
      break;

    case 'touki-all':
      // 登記簿PDF統合フロー（ハイライト + CSV + ジャンプ）
      vm.handleToukiAll(files);
      break;

    case 'kyuseki-import':
      // 求積表インポート
      vm.$store.state.kyusekiInitialFile = file;
      vm.openKyusekiDialog();
      break;

    case 'gps-photos-import':
      // GPS写真インポート
      vm.handleGpsPhotosImport(files);
      break;

    case 'photo-memo':
      // 写真メモ
      vm.$store.state.pendingPhotoMemoFiles = files;
      vm.$store.dispatch('showFloatingWindow', 'photo-memo-upload');
      break;

    case 'geojson-to-chibanzu':
      // 地番図アップロード
      vm.uploadChibanzu();
      break;

    case 'geojson-to-mylayer':
      // マイレイヤー追加
      vm.dialogForLayerName = true;
      break;

    case 'geojson-to-draw':
      // ドロー追加
      vm.uploadDraw();
      break;

    case 'shapefile-import':
      try {
        vm.loadingSnackbar = true;
        vm.s_loading = true;
        const arrayBuffer = await file.arrayBuffer();
        const geojson = await shp(arrayBuffer);
        const firstFeature = geojson.features[0];
        vm.s_chibanzuPropaties = Object.keys(firstFeature.properties);
        vm.s_chibanzuGeojson = geojson;
        vm.loadingSnackbar = false;
        vm.s_loading = false;
        vm.s_showChibanzuDialog = true;
      } catch (e) {
        alert('シェイプファイルをgeojsonに変換できませんでした。');
        vm.loadingSnackbar = false;
        vm.s_loading = false;
      }
      break;

    case 'dxf-import':
      vm.$store.state.tiffAndWorldFile = files;
      reader.onload = async (event) => {
        const dxfText = event.target.result;
        vm.$store.state.dxfText = {
          text: dxfText,
          zahyokei: ''
        };
        vm.dialogForDxfApp = true;
      };
      reader.readAsText(file);
      break;

    case 'csv-import':
      vm.csvRecords = await parseCSV(file);
      vm.csvLonLat = detectLatLonColumns(vm.csvRecords);
      vm.csvColumns = Object.keys(vm.csvRecords[0]);
      // デフォルトタブを推定して自動選択
      if (vm.csvLonLat) {
        // 緯度経度が見つかった → WGS84 タブ
        vm.csvImportMode = 'wgs84';
        vm.csvLonColumn = vm.csvLonLat.lon;
        vm.csvLatColumn = vm.csvLonLat.lat;
      } else {
        // x/y 列があって数値なら公共座標系の可能性が高い
        const xCand = vm.csvColumns.find((c: string) => /^x$/i.test(c) || /経度/.test(c));
        const yCand = vm.csvColumns.find((c: string) => /^y$/i.test(c) || /緯度/.test(c));
        const isNum = (v: any) => v !== '' && v != null && !isNaN(parseFloat(v));
        if (xCand && yCand && vm.csvRecords.slice(0, 5).every((r: any) => isNum(r[xCand]) && isNum(r[yCand]))) {
          vm.csvImportMode = 'jprcs';
          vm.csvXColumn = xCand;
          vm.csvYColumn = yCand;
        } else {
          vm.csvImportMode = 'geocode';
        }
      }
      // ラベル列のデフォルト: name があれば name
      if (!vm.csvLabelColumn) {
        const nameCand = vm.csvColumns.find((c: string) => /^name$/i.test(c) || /名前|名称/.test(c));
        if (nameCand) vm.csvLabelColumn = nameCand;
      }
      vm.dialogForDrawCsv = true;
      break;

    case 'gpx-import': {
      const gpxText = await file.text();
      const parser = new DOMParser();
      const gpxDoc = parser.parseFromString(gpxText, 'application/xml');
      const gpxGeojson = gpx(gpxDoc);
      gpxGeojson.features.forEach(feature => {
        const id = String(Math.floor(10000 + Math.random() * 90000));
        feature.properties['id'] = id;
        feature.properties['color'] = 'blue';
        feature.properties['line-width'] = 5;
        feature.properties['arrow-type'] = 'none';
      });
      const source = map.getSource(clickCircleSource.iD);
      const drawGeojson = vm.getSourceData(source);
      if (drawGeojson) {
        drawGeojson.features.push(...gpxGeojson.features);
        map.getSource(clickCircleSource.iD).setData(drawGeojson);
        vm.$store.state.clickCircleGeojsonText = JSON.stringify(drawGeojson);
      }
      const bbox = turf.bbox(gpxGeojson);
      map.fitBounds(bbox, {
        padding: 40,
        duration: 1000,
        linear: false
      });
      break;
    }

    case 'xml-import': {
      if (file && file.type === 'text/xml') {
        const xmlText = await file.text();
        let geojson = xmlToGeojson(xmlText);
        geojson = transformGeoJSONToEPSG4326(geojson);
        geojsonAddLayer(map, geojson, true, fileExtension);
      } else {
        alert('XMLファイルをドロップしてください');
      }
      break;
    }

    default:
      console.warn('Unknown flow action:', flowAction);
  }

  // アクションをリセット
  vm.$store.commit('setFileDropFlowAction', { action: null, files: [] });
}

/**
 * 登記簿PDF → 地図ジャンプ
 */
export async function handleToukiJump(vm: VM, files: any): Promise<void> {
  const { parseToukiPdf, normalizeAddressForGeocoding } = await import('@/js/toukiPdfParser')
  const { showInfo, showError } = await import('@/js/utils/messageHelper')

  if (!files || files.length === 0) {
    showError('PDFファイルが選択されていません')
    return
  }

  const file = files[0]
  // showInfo('登記簿PDFを解析中...') // コメントアウト

  try {
    // 1. PDFから所在・地番を抽出
    const toukiInfo = await parseToukiPdf(file)

    if (!toukiInfo.success) {
      showError(toukiInfo.error || '登記簿の解析に失敗しました')
      return
    }

    // 2. 所在をジオコーディング用に正規化
    const searchAddress = normalizeAddressForGeocoding(toukiInfo.shozai)

    // 3. 国土地理院ジオコーディングAPIで座標取得
    const gsiResponse = await fetch(
      `https://msearch.gsi.go.jp/address-search/AddressSearch?q=${encodeURIComponent(searchAddress)}`
    )
    const gsiData = await gsiResponse.json()

    if (!gsiData || gsiData.length === 0) {
      showError(`住所が見つかりませんでした: ${searchAddress}`)
      return
    }

    // 最初の結果を使用
    const [lng, lat] = gsiData[0].geometry.coordinates

    // 4. 地図にジャンプ
    const map = vm.$store.state.map01
    if (map) {
      // 5. 2025登記所地図レイヤーをONにする（flyToの前に実行）
      const layerId = 'oh-homusyo-2025-layer'
      const selectedLayers = vm.$store.state.selectedLayers.map01 || []
      const isLayerActive = selectedLayers.some(l => l.id === layerId)

      if (!isLayerActive) {
        // レイヤーツリーからノードを検索
        const findLayerById = (tree, targetId) => {
          if (!tree) return null
          for (const node of tree) {
            if (node.id === targetId) return node
            if (node.nodes) {
              const found = findLayerById(node.nodes, targetId)
              if (found) return found
            }
            if (node.children) {
              const found = findLayerById(node.children, targetId)
              if (found) return found
            }
          }
          return null
        }

        const node = findLayerById(Layers.layers.map01, layerId)
        if (node) {
          const layerObj = {
            id: node.id,
            label: node.label,
            source: node.source,
            sources: node.sources,
            layer: node.layer,
            layers: node.layers,
            opacity: 0.7,
            visibility: true,
            attribution: node.attribution,
            ext: node.ext,
            info: node.info,
            position: node.position
          }
          vm.$store.commit('TOGGLE_SELECTED_LAYER', {
            mapName: 'map01',
            layer: layerObj
          })
        }
      }

      // 6. 地番ポリゴンをハイライト関数
      const searchAndHighlightChiban = () => {
        // 地番をクエリ用に正規化（「125番1」→「125-1」など複数パターンで検索）
        const chiban = toukiInfo.chiban
        const chibanPatterns = [
          chiban,
          chiban.replace('番', '-')
        ]

        // レイヤーが存在するか確認
        if (!map.getLayer('oh-homusyo-2025-polygon')) {
          return false
        }

        // 画面全体から検索
        const allFeatures = map.queryRenderedFeatures(
          { layers: ['oh-homusyo-2025-polygon'] }
        )


        if (allFeatures.length === 0) {
          return false // まだロードされていない
        }

        // 所在から町名/大字名を抽出して比較用キーワードを作成
        // 例: "大牟田市日出町2丁目" → ["日出町2丁目", "日出町二丁目"]（丁目指定時は厳密マッチ）
        // 例: "大牟田市新栄町" → ["新栄町", "新栄"]
        // 例: "大牟田市大字橘" → ["大字橘", "橘"]
        const shozaiKeywords = []
        const shozai = toukiInfo.shozai || ''
        // 市区郡の後の部分を抽出（丁目も含める）
        const fullMatch = shozai.match(/[市区郡]([^市区郡]+)$/)
        if (fullMatch && fullMatch[1]) {
          const townPart = fullMatch[1]
          shozaiKeywords.push(townPart)
          // 丁目付きの場合、漢数字バージョンを追加（フォールバックなし＝厳密マッチ）
          const chomeNumMatch = townPart.match(/^(.+?)(\d+)(丁目)$/)
          if (chomeNumMatch) {
            const baseTown = chomeNumMatch[1]
            const num = parseInt(chomeNumMatch[2])
            const kanjiNums = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
            if (num <= 10) {
              shozaiKeywords.push(`${baseTown}${kanjiNums[num]}丁目`)
            }
            // 丁目番号付きの場合はフォールバックキーワードを追加しない
            // これにより日出町2丁目は日出町1丁目にマッチしなくなる
          } else {
            if (townPart.startsWith('大字')) {
              shozaiKeywords.push(townPart.replace('大字', ''))
            }
            if (townPart.endsWith('町')) {
              shozaiKeywords.push(townPart.replace(/町$/, ''))
            }
          }
        }

        // 地番と所在の両方が一致するフィーチャーを検索
        const matchedFeature = allFeatures.find(f => {
          const featureChiban = f.properties?.地番 || ''
          const chibanMatch = chibanPatterns.some(p => featureChiban === p)
          if (!chibanMatch) return false

          // 所在も確認（キーワードがある場合のみ）
          if (shozaiKeywords.length > 0) {
            const oaza = f.properties?.大字名 || ''
            const chome = f.properties?.丁目名 || ''
            const muni = f.properties?.市区町村名 || ''
            const featureShozai = `${muni}${oaza}${chome}`

            // キーワードのいずれかが含まれているか確認
            const shozaiMatch = shozaiKeywords.some(kw =>
              featureShozai.includes(kw) || oaza.includes(kw) || chome.includes(kw)
            )
            if (!shozaiMatch) {
              return false
            }
          }

          return true
        })

        if (matchedFeature) {
          vm.highlightToukiPolygon(matchedFeature)
          return 'matched'
        } else {
          // デバッグ: 地番だけマッチしたものを表示
          const chibanOnlyMatches = allFeatures.filter(f => {
            const featureChiban = f.properties?.地番 || ''
            return chibanPatterns.some(p => featureChiban === p)
          })
          return 'not_found' // フィーチャーは見つかったがマッチしなかった
        }
      }

      // タイルロード完了を待って検索（setTimeoutで段階的にリトライ）
      const retrySearch = (attempt = 1, maxAttempts = 10) => {
        const result = searchAndHighlightChiban()
        if (result === 'matched') {
          return // 成功
        }
        if (result === 'not_found') {
          // 地番が見つからなかった
          showInfo(`地番 <strong>${toukiInfo.chiban}</strong> が見つかりませんでした。<br>画面内に該当の筆がない可能性があります。`, {
            icon: 'mdi-map-marker-question',
            iconColor: 'info'
          })
          return
        }
        // result === false の場合はリトライ
        if (attempt < maxAttempts) {
          setTimeout(() => retrySearch(attempt + 1, maxAttempts), 1000)
        } else {
          showInfo('登記所地図データの読み込みがタイムアウトしました。', {
            icon: 'mdi-timer-sand-empty',
            iconColor: 'warning'
          })
        }
      }

      // flyTo完了後（duration + マージン）に検索開始
      const flyDuration = 1500
      setTimeout(() => {
        retrySearch()
      }, flyDuration + 500)

      // 地図をジャンプ
      map.flyTo({
        center: [lng, lat],
        zoom: 17,
        duration: flyDuration
      })

      // 成功メッセージ（コメントアウト：あとで復活するかも）
      // showInfo(`${toukiInfo.shozai} ${toukiInfo.chiban} にジャンプしました`)
    }
  } catch (error) {
    console.error('[ToukiJump] Error:', error)
    showError(`エラーが発生しました: ${error.message || error}`)
  }
}

